/**
 * Element UI 图标类名整理
 * 使用方式：<i class="el-icon-图标名"></i>
 * 例如：<i class="el-icon-edit"></i>
 */

export const elementIcons = {
  // 基础图标
  basic: [
    'el-icon-info',
    'el-icon-error',
    'el-icon-success',
    'el-icon-warning',
    'el-icon-question',
    'el-icon-remove',
    'el-icon-circle-plus',
    'el-icon-circle-close',
    'el-icon-s-help',
    'el-icon-s-operation',
    'el-icon-s-platform',
    'el-icon-s-fold',
    'el-icon-s-unfold',
    'el-icon-s-promotion',
    'el-icon-s-home',
    'el-icon-s-release',
    'el-icon-s-ticket',
    'el-icon-s-management',
    'el-icon-s-open',
    'el-icon-s-shop',
    'el-icon-s-marketing',
    'el-icon-s-flag',
    'el-icon-s-comment',
    'el-icon-s-finance',
    'el-icon-s-claim',
    'el-icon-s-custom',
    'el-icon-s-opportunity',
    'el-icon-s-data',
    'el-icon-s-check',
    'el-icon-s-grid',
    'el-icon-menu',
    'el-icon-share',
    'el-icon-d-caret',
    'el-icon-caret-left',
    'el-icon-caret-right',
    'el-icon-caret-bottom',
    'el-icon-caret-top',
    'el-icon-bottom-left',
    'el-icon-bottom-right',
    'el-icon-back',
    'el-icon-right',
    'el-icon-bottom',
    'el-icon-top',
    'el-icon-top-left',
    'el-icon-top-right',
    'el-icon-arrow-left',
    'el-icon-arrow-right',
    'el-icon-arrow-down',
    'el-icon-arrow-up',
    'el-icon-d-arrow-left',
    'el-icon-d-arrow-right',
    'el-icon-video-pause',
    'el-icon-video-play',
    'el-icon-refresh',
    'el-icon-refresh-right',
    'el-icon-refresh-left',
    'el-icon-finished',
    'el-icon-sort',
    'el-icon-sort-up',
    'el-icon-sort-down',
    'el-icon-rank',
    'el-icon-loading',
    'el-icon-view',
    'el-icon-c-scale-to-original',
    'el-icon-date',
    'el-icon-edit',
    'el-icon-edit-outline',
    'el-icon-folder',
    'el-icon-folder-opened',
    'el-icon-folder-add',
    'el-icon-folder-remove',
    'el-icon-folder-delete',
    'el-icon-folder-checked',
    'el-icon-tickets',
    'el-icon-document-remove',
    'el-icon-document-delete',
    'el-icon-document-copy',
    'el-icon-document-checked',
    'el-icon-document',
    'el-icon-document-add',
    'el-icon-printer',
    'el-icon-paperclip',
    'el-icon-takeaway-box',
    'el-icon-search',
    'el-icon-monitor',
    'el-icon-attract',
    'el-icon-mobile',
    'el-icon-scissors',
    'el-icon-umbrella',
    'el-icon-headset',
    'el-icon-brush',
    'el-icon-mouse',
    'el-icon-coordinate',
    'el-icon-magic-stick',
    'el-icon-reading',
    'el-icon-data-line',
    'el-icon-data-board',
    'el-icon-pie-chart',
    'el-icon-data-analysis',
    'el-icon-collection-tag',
    'el-icon-film',
    'el-icon-suitcase',
    'el-icon-suitcase-1',
    'el-icon-receiving',
    'el-icon-collection',
    'el-icon-files',
    'el-icon-notebook-1',
    'el-icon-notebook-2',
    'el-icon-toilet-paper',
    'el-icon-office-building',
    'el-icon-school',
    'el-icon-table-lamp',
    'el-icon-house',
    'el-icon-no-smoking',
    'el-icon-smoking',
    'el-icon-shopping-cart-full',
    'el-icon-shopping-cart-1',
    'el-icon-shopping-cart-2',
    'el-icon-shopping-bag-1',
    'el-icon-shopping-bag-2',
    'el-icon-sold-out',
    'el-icon-sell',
    'el-icon-present',
    'el-icon-box',
    'el-icon-bank-card',
    'el-icon-money',
    'el-icon-coin',
    'el-icon-wallet'
  ],

  // 操作图标
  actions: [
    'el-icon-plus',
    'el-icon-minus',
    'el-icon-close',
    'el-icon-check',
    'el-icon-remove-outline',
    'el-icon-circle-plus-outline',
    'el-icon-remove',
    'el-icon-circle-plus',
    'el-icon-circle-close',
    'el-icon-s-help',
    'el-icon-s-operation',
    'el-icon-s-platform',
    'el-icon-s-fold',
    'el-icon-s-unfold',
    'el-icon-s-promotion',
    'el-icon-s-home',
    'el-icon-s-release',
    'el-icon-s-ticket',
    'el-icon-s-management',
    'el-icon-s-open',
    'el-icon-s-shop',
    'el-icon-s-marketing',
    'el-icon-s-flag',
    'el-icon-s-comment',
    'el-icon-s-finance',
    'el-icon-s-claim',
    'el-icon-s-custom',
    'el-icon-s-opportunity',
    'el-icon-s-data',
    'el-icon-s-check',
    'el-icon-s-grid',
    'el-icon-menu',
    'el-icon-share',
    'el-icon-d-caret',
    'el-icon-caret-left',
    'el-icon-caret-right',
    'el-icon-caret-bottom',
    'el-icon-caret-top',
    'el-icon-bottom-left',
    'el-icon-bottom-right',
    'el-icon-back',
    'el-icon-right',
    'el-icon-bottom',
    'el-icon-top',
    'el-icon-top-left',
    'el-icon-top-right',
    'el-icon-arrow-left',
    'el-icon-arrow-right',
    'el-icon-arrow-down',
    'el-icon-arrow-up',
    'el-icon-d-arrow-left',
    'el-icon-d-arrow-right',
    'el-icon-video-pause',
    'el-icon-video-play',
    'el-icon-refresh',
    'el-icon-refresh-right',
    'el-icon-refresh-left',
    'el-icon-finished',
    'el-icon-sort',
    'el-icon-sort-up',
    'el-icon-sort-down',
    'el-icon-rank',
    'el-icon-loading',
    'el-icon-view',
    'el-icon-c-scale-to-original',
    'el-icon-date',
    'el-icon-edit',
    'el-icon-edit-outline',
    'el-icon-folder',
    'el-icon-folder-opened',
    'el-icon-folder-add',
    'el-icon-folder-remove',
    'el-icon-folder-delete',
    'el-icon-folder-checked',
    'el-icon-tickets',
    'el-icon-document-remove',
    'el-icon-document-delete',
    'el-icon-document-copy',
    'el-icon-document-checked',
    'el-icon-document',
    'el-icon-document-add',
    'el-icon-printer',
    'el-icon-paperclip',
    'el-icon-takeaway-box',
    'el-icon-search',
    'el-icon-monitor',
    'el-icon-attract',
    'el-icon-mobile',
    'el-icon-scissors',
    'el-icon-umbrella',
    'el-icon-headset',
    'el-icon-brush',
    'el-icon-mouse',
    'el-icon-coordinate',
    'el-icon-magic-stick',
    'el-icon-reading',
    'el-icon-data-line',
    'el-icon-data-board',
    'el-icon-pie-chart',
    'el-icon-data-analysis',
    'el-icon-collection-tag',
    'el-icon-film',
    'el-icon-suitcase',
    'el-icon-suitcase-1',
    'el-icon-receiving',
    'el-icon-collection',
    'el-icon-files',
    'el-icon-notebook-1',
    'el-icon-notebook-2',
    'el-icon-toilet-paper',
    'el-icon-office-building',
    'el-icon-school',
    'el-icon-table-lamp',
    'el-icon-house',
    'el-icon-no-smoking',
    'el-icon-smoking',
    'el-icon-shopping-cart-full',
    'el-icon-shopping-cart-1',
    'el-icon-shopping-cart-2',
    'el-icon-shopping-bag-1',
    'el-icon-shopping-bag-2',
    'el-icon-sold-out',
    'el-icon-sell',
    'el-icon-present',
    'el-icon-box',
    'el-icon-bank-card',
    'el-icon-money',
    'el-icon-coin',
    'el-icon-wallet'
  ],

  // 导航图标
  navigation: [
    'el-icon-arrow-left',
    'el-icon-arrow-right',
    'el-icon-arrow-down',
    'el-icon-arrow-up',
    'el-icon-d-arrow-left',
    'el-icon-d-arrow-right',
    'el-icon-caret-left',
    'el-icon-caret-right',
    'el-icon-caret-bottom',
    'el-icon-caret-top',
    'el-icon-d-caret',
    'el-icon-back',
    'el-icon-right',
    'el-icon-bottom',
    'el-icon-top',
    'el-icon-top-left',
    'el-icon-top-right',
    'el-icon-bottom-left',
    'el-icon-bottom-right'
  ],

  // 状态图标
  status: [
    'el-icon-success',
    'el-icon-error',
    'el-icon-warning',
    'el-icon-info',
    'el-icon-question',
    'el-icon-loading',
    'el-icon-finished',
    'el-icon-check',
    'el-icon-close',
    'el-icon-remove',
    'el-icon-circle-plus',
    'el-icon-circle-close',
    'el-icon-circle-plus-outline',
    'el-icon-remove-outline'
  ],

  // 文件图标
  files: [
    'el-icon-document',
    'el-icon-document-add',
    'el-icon-document-remove',
    'el-icon-document-delete',
    'el-icon-document-copy',
    'el-icon-document-checked',
    'el-icon-folder',
    'el-icon-folder-opened',
    'el-icon-folder-add',
    'el-icon-folder-remove',
    'el-icon-folder-delete',
    'el-icon-folder-checked',
    'el-icon-files',
    'el-icon-tickets',
    'el-icon-paperclip',
    'el-icon-printer'
  ],

  // 编辑图标
  edit: [
    'el-icon-edit',
    'el-icon-edit-outline',
    'el-icon-brush',
    'el-icon-scissors',
    'el-icon-magic-stick',
    'el-icon-coordinate',
    'el-icon-mouse'
  ],

  // 数据图表图标
  charts: [
    'el-icon-pie-chart',
    'el-icon-data-line',
    'el-icon-data-board',
    'el-icon-data-analysis',
    'el-icon-s-data',
    'el-icon-s-grid',
    'el-icon-s-check',
    'el-icon-s-flag',
    'el-icon-s-marketing',
    'el-icon-s-finance',
    'el-icon-s-opportunity',
    'el-icon-s-claim',
    'el-icon-s-custom',
    'el-icon-s-comment',
    'el-icon-s-ticket',
    'el-icon-s-management',
    'el-icon-s-open',
    'el-icon-s-shop',
    'el-icon-s-promotion',
    'el-icon-s-home',
    'el-icon-s-release',
    'el-icon-s-platform',
    'el-icon-s-operation',
    'el-icon-s-help',
    'el-icon-s-fold',
    'el-icon-s-unfold'
  ],

  // 媒体图标
  media: [
    'el-icon-video-play',
    'el-icon-video-pause',
    'el-icon-film',
    'el-icon-headset',
    'el-icon-monitor',
    'el-icon-mobile'
  ],

  // 购物图标
  shopping: [
    'el-icon-shopping-cart-full',
    'el-icon-shopping-cart-1',
    'el-icon-shopping-cart-2',
    'el-icon-shopping-bag-1',
    'el-icon-shopping-bag-2',
    'el-icon-sold-out',
    'el-icon-sell',
    'el-icon-present',
    'el-icon-box',
    'el-icon-bank-card',
    'el-icon-money',
    'el-icon-coin',
    'el-icon-wallet'
  ],

  // 建筑图标
  building: [
    'el-icon-office-building',
    'el-icon-school',
    'el-icon-house',
    'el-icon-table-lamp'
  ],

  // 其他图标
  others: [
    'el-icon-search',
    'el-icon-refresh',
    'el-icon-refresh-right',
    'el-icon-refresh-left',
    'el-icon-sort',
    'el-icon-sort-up',
    'el-icon-sort-down',
    'el-icon-rank',
    'el-icon-view',
    'el-icon-c-scale-to-original',
    'el-icon-date',
    'el-icon-menu',
    'el-icon-share',
    'el-icon-collection',
    'el-icon-collection-tag',
    'el-icon-receiving',
    'el-icon-suitcase',
    'el-icon-suitcase-1',
    'el-icon-notebook-1',
    'el-icon-notebook-2',
    'el-icon-toilet-paper',
    'el-icon-no-smoking',
    'el-icon-smoking',
    'el-icon-takeaway-box',
    'el-icon-attract',
    'el-icon-umbrella',
    'el-icon-reading'
  ]
}

// 按字母顺序排列的所有图标
export const allIcons = [
  'el-icon-arrow-down',
  'el-icon-arrow-left',
  'el-icon-arrow-right',
  'el-icon-arrow-up',
  'el-icon-attract',
  'el-icon-back',
  'el-icon-bank-card',
  'el-icon-bottom',
  'el-icon-bottom-left',
  'el-icon-bottom-right',
  'el-icon-box',
  'el-icon-brush',
  'el-icon-caret-bottom',
  'el-icon-caret-left',
  'el-icon-caret-right',
  'el-icon-caret-top',
  'el-icon-check',
  'el-icon-circle-close',
  'el-icon-circle-plus',
  'el-icon-circle-plus-outline',
  'el-icon-c-scale-to-original',
  'el-icon-close',
  'el-icon-coin',
  'el-icon-collection',
  'el-icon-collection-tag',
  'el-icon-coordinate',
  'el-icon-d-arrow-left',
  'el-icon-d-arrow-right',
  'el-icon-d-caret',
  'el-icon-data-analysis',
  'el-icon-data-board',
  'el-icon-data-line',
  'el-icon-date',
  'el-icon-document',
  'el-icon-document-add',
  'el-icon-document-checked',
  'el-icon-document-copy',
  'el-icon-document-delete',
  'el-icon-document-remove',
  'el-icon-edit',
  'el-icon-edit-outline',
  'el-icon-error',
  'el-icon-files',
  'el-icon-film',
  'el-icon-finished',
  'el-icon-folder',
  'el-icon-folder-add',
  'el-icon-folder-checked',
  'el-icon-folder-delete',
  'el-icon-folder-opened',
  'el-icon-folder-remove',
  'el-icon-headset',
  'el-icon-house',
  'el-icon-info',
  'el-icon-loading',
  'el-icon-magic-stick',
  'el-icon-menu',
  'el-icon-minus',
  'el-icon-mobile',
  'el-icon-money',
  'el-icon-monitor',
  'el-icon-mouse',
  'el-icon-no-smoking',
  'el-icon-notebook-1',
  'el-icon-notebook-2',
  'el-icon-office-building',
  'el-icon-paperclip',
  'el-icon-pie-chart',
  'el-icon-plus',
  'el-icon-printer',
  'el-icon-question',
  'el-icon-rank',
  'el-icon-reading',
  'el-icon-receiving',
  'el-icon-refresh',
  'el-icon-refresh-left',
  'el-icon-refresh-right',
  'el-icon-remove',
  'el-icon-remove-outline',
  'el-icon-right',
  'el-icon-s-check',
  'el-icon-s-claim',
  'el-icon-s-comment',
  'el-icon-s-custom',
  'el-icon-s-data',
  'el-icon-s-finance',
  'el-icon-s-flag',
  'el-icon-s-fold',
  'el-icon-s-grid',
  'el-icon-s-help',
  'el-icon-s-home',
  'el-icon-s-management',
  'el-icon-s-marketing',
  'el-icon-s-open',
  'el-icon-s-operation',
  'el-icon-s-opportunity',
  'el-icon-s-platform',
  'el-icon-s-promotion',
  'el-icon-s-release',
  'el-icon-s-shop',
  'el-icon-s-ticket',
  'el-icon-s-unfold',
  'el-icon-school',
  'el-icon-scissors',
  'el-icon-search',
  'el-icon-sell',
  'el-icon-share',
  'el-icon-shopping-bag-1',
  'el-icon-shopping-bag-2',
  'el-icon-shopping-cart-1',
  'el-icon-shopping-cart-2',
  'el-icon-shopping-cart-full',
  'el-icon-smoking',
  'el-icon-sold-out',
  'el-icon-sort',
  'el-icon-sort-down',
  'el-icon-sort-up',
  'el-icon-success',
  'el-icon-suitcase',
  'el-icon-suitcase-1',
  'el-icon-table-lamp',
  'el-icon-takeaway-box',
  'el-icon-tickets',
  'el-icon-toilet-paper',
  'el-icon-top',
  'el-icon-top-left',
  'el-icon-top-right',
  'el-icon-umbrella',
  'el-icon-video-pause',
  'el-icon-video-play',
  'el-icon-view',
  'el-icon-wallet',
  'el-icon-warning'
]

// 常用图标推荐
export const commonIcons = [
  'el-icon-plus',           // 添加
  'el-icon-minus',          // 删除
  'el-icon-edit',           // 编辑
  'el-icon-delete',         // 删除
  'el-icon-search',         // 搜索
  'el-icon-refresh',        // 刷新
  'el-icon-arrow-left',     // 左箭头
  'el-icon-arrow-right',    // 右箭头
  'el-icon-arrow-up',       // 上箭头
  'el-icon-arrow-down',     // 下箭头
  'el-icon-success',        // 成功
  'el-icon-error',          // 错误
  'el-icon-warning',        // 警告
  'el-icon-info',           // 信息
  'el-icon-close',          // 关闭
  'el-icon-check',          // 确认
  'el-icon-loading',        // 加载中
  'el-icon-view',           // 查看
  'el-icon-document',       // 文档
  'el-icon-folder',         // 文件夹
  'el-icon-pie-chart',      // 饼图
  'el-icon-data-line',      // 折线图
  'el-icon-data-board',     // 数据看板
  'el-icon-data-analysis',  // 数据分析
  'el-icon-menu',           // 菜单
  'el-icon-share',          // 分享
  'el-icon-date',           // 日期
  'el-icon-sort',           // 排序
  'el-icon-rank',           // 排名
  'el-icon-monitor',        // 监控
  'el-icon-mobile',         // 移动端
  'el-icon-printer',        // 打印
  'el-icon-paperclip',      // 附件
  'el-icon-collection',     // 收藏
  'el-icon-suitcase',       // 工具箱
  'el-icon-office-building', // 办公楼
  'el-icon-school',         // 学校
  'el-icon-house',          // 房屋
  'el-icon-table-lamp',     // 台灯
  'el-icon-money',          // 金钱
  'el-icon-wallet',         // 钱包
  'el-icon-bank-card',      // 银行卡
  'el-icon-coin',           // 硬币
  'el-icon-shopping-cart-full', // 购物车
  'el-icon-sell',           // 销售
  'el-icon-present',        // 礼物
  'el-icon-box',            // 盒子
  'el-icon-film',           // 电影
  'el-icon-headset',        // 耳机
  'el-icon-brush',          // 画笔
  'el-icon-mouse',          // 鼠标
  'el-icon-coordinate',     // 坐标
  'el-icon-magic-stick',    // 魔法棒
  'el-icon-reading',        // 阅读
  'el-icon-attract',        // 吸引
  'el-icon-umbrella',       // 雨伞
  'el-icon-scissors',       // 剪刀
  'el-icon-takeaway-box',   // 外卖盒
  'el-icon-no-smoking',     // 禁烟
  'el-icon-smoking',        // 吸烟
  'el-icon-toilet-paper',   // 卫生纸
  'el-icon-notebook-1',     // 笔记本1
  'el-icon-notebook-2',     // 笔记本2
  'el-icon-receiving',      // 接收
  'el-icon-files',          // 文件
  'el-icon-tickets',        // 票据
  'el-icon-sold-out',       // 售罄
  'el-icon-shopping-bag-1', // 购物袋1
  'el-icon-shopping-bag-2', // 购物袋2
  'el-icon-shopping-cart-1', // 购物车1
  'el-icon-shopping-cart-2', // 购物车2
  'el-icon-suitcase-1',     // 工具箱1
  'el-icon-video-play',     // 播放
  'el-icon-video-pause',    // 暂停
  'el-icon-sort-up',        // 升序
  'el-icon-sort-down',      // 降序
  'el-icon-refresh-left',   // 左刷新
  'el-icon-refresh-right',  // 右刷新
  'el-icon-finished',       // 完成
  'el-icon-remove-outline', // 移除轮廓
  'el-icon-circle-plus-outline', // 圆形加号轮廓
  'el-icon-document-add',   // 添加文档
  'el-icon-document-remove', // 移除文档
  'el-icon-document-delete', // 删除文档
  'el-icon-document-copy',  // 复制文档
  'el-icon-document-checked', // 已检查文档
  'el-icon-folder-add',     // 添加文件夹
  'el-icon-folder-remove',  // 移除文件夹
  'el-icon-folder-delete',  // 删除文件夹
  'el-icon-folder-checked', // 已检查文件夹
  'el-icon-folder-opened',  // 打开的文件夹
  'el-icon-edit-outline',   // 编辑轮廓
  'el-icon-circle-close',   // 圆形关闭
  'el-icon-circle-plus',    // 圆形加号
  'el-icon-remove',         // 移除
  'el-icon-question',       // 问题
  'el-icon-s-help',         // 帮助
  'el-icon-s-operation',    // 操作
  'el-icon-s-platform',     // 平台
  'el-icon-s-fold',         // 折叠
  'el-icon-s-unfold',       // 展开
  'el-icon-s-promotion',    // 推广
  'el-icon-s-home',         // 首页
  'el-icon-s-release',      // 发布
  'el-icon-s-ticket',       // 票据
  'el-icon-s-management',   // 管理
  'el-icon-s-open',         // 打开
  'el-icon-s-shop',         // 商店
  'el-icon-s-marketing',    // 营销
  'el-icon-s-flag',         // 旗帜
  'el-icon-s-comment',      // 评论
  'el-icon-s-finance',      // 财务
  'el-icon-s-claim',        // 声明
  'el-icon-s-custom',       // 自定义
  'el-icon-s-opportunity',  // 机会
  'el-icon-s-data',         // 数据
  'el-icon-s-check',        // 检查
  'el-icon-s-grid',         // 网格
  'el-icon-d-arrow-left',   // 双左箭头
  'el-icon-d-arrow-right',  // 双右箭头
  'el-icon-d-caret',        // 双箭头
  'el-icon-c-scale-to-original' // 缩放到原始大小
]

export default {
  elementIcons,
  allIcons,
  commonIcons
}
